// @flow
import { Link } from 'react-router-dom'
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import type { VotePreference } from 'components/questionnaire'
import './styles.scss'

type Props = {
  votePreferences: VotePreference,
  setLoading: () => void,
  unsetLoading: () => void,
  articleId: string,
  match: any
}

type State = {
  articleText: ?string,
  errorMessage: ?string
}

type Vote = 'yes' | 'no' | ''

export class Article extends React.Component<Props, State> {
  state = {
    articleText: null,
    errorMessage: null
  }

  /**
   * Retrieves processed texts from initial wordsmith templates
   *
   * @param  bfs Commune UID
   * @param velo "yes", "no" or undefined, defines the user vote
   * @param fair "yes", "no" or undefined, defines the user vote
   * @param safety "yes", "no" or undefined, defines the user vote
   * @param baseUrl
   */
  static getVoteText (
    bfs: string,
    velo: Vote,
    fair: Vote,
    safety: Vote,
    baseUrl?: string
  ) {
    const BASE_URL = baseUrl || 'https://vote-backend.tamedia.ch'
    const API_ENDPOINT = '/api/v1/gettext/'
    const url =
      BASE_URL +
      API_ENDPOINT +
      bfs +
      `?velo=${velo}&fair=${fair}&safety=${safety}`
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }).then(response => response.json())
  }

  componentDidMount () {
    this.props.setLoading()
    const vp = this.props.votePreferences
    const prefs = [
      vp.velo === null ? '' : vp.velo ? 'yes' : 'no',
      vp.fairFood === null ? '' : vp.fairFood ? 'yes' : 'no',
      vp.ernaehrung === null ? '' : vp.ernaehrung ? 'yes' : 'no'
    ]

    Article.getVoteText(this.props.match.params.municipalityId, ...prefs)
      .then((data: { req_id: string, content: string }) => {
        this.setState({ articleText: data.content })
        this.props.unsetLoading()
      })
      .catch(reason => {
        this.props.unsetLoading()
        this.setState({ errorMessage: reason.message })
      })
  }

  render () {
    return (
      <div className='step article' style={{ zIndex: 10 }}>
        {this.state.articleText && (
          <React.Fragment>
            <h2 className='ui header'>
              <div className='sub header'>
                Für Sie schrieb Tobi folgenden Artikel:
              </div>
            </h2>

            <div className='ui text container'>
              <div className='ui raised segment'>
                <div
                  dangerouslySetInnerHTML={{ __html: this.state.articleText }}
                />
                <div className='ui divider' />
                <p>
                  <cite>Ihr Tobi, Textroboter</cite> 🤖
                </p>
              </div>
            </div>
          </React.Fragment>
        )}

        {this.state.errorMessage && (
          <div className='ui error icon message'>
            <i className='warning circle icon' />
            <div className='content'>
              <div className='header'>Leider erlitt Tobi eine Fehlfunktion</div>
              <p>Grund für das Missgeschick: {this.state.errorMessage}</p>
            </div>
          </div>
        )}

        <div className='ui vertical segment'>
          <div className='ui grid'>
            <div className='two column stackable row'>
              <div className='column'>
                <Link
                  to={'/gemeindeauswahl'}
                  className='ui basic icon labeled
              button'
                >
                  <i className='undo icon' />
                  Zurücksetzen
                </Link>

                <FeedbackMessage
                  question='Hat Tobi einen Fehler gemacht?'
                  call='Lassen Sie es uns wissen. Schreiben Sie uns eine'
                  mailTo='titus.plattner@tamedia.ch,marc.brupbacher@tamedia.ch'
                  project='Tobi'
                />
              </div>
              <div className='column'>
                <UserFeedback
                  articleId={this.props.articleId}
                  questions={[
                    'Funktionierte die technische Umsetzung?',
                    'Wie beurteilen Sie die Textqualität?',
                    'Wie beurteilen Sie den Nutzen dieses Textes?'
                  ]}
                  starColor='orange'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/article/index.js